export const DBA_PUBLISH_LOGS_RESET_STATE = 'DBA_PUBLISH_LOGS_RESET_STATE';
export const DBA_PUBLISH_LOGS_CURRENT_ITEM = 'DBA_PUBLISH_LOGS_CURRENT_ITEM';

export const DBA_PUBLISH_LOGS_REQUEST_LOADING = 'DBA_PUBLISH_LOGS_REQUEST_LOADING';
export const DBA_PUBLISH_LOGS_REQUEST_SUCCESS = 'DBA_PUBLISH_LOGS_REQUEST_SUCCESS';
export const DBA_PUBLISH_LOGS_REQUEST_FAILED = 'DBA_PUBLISH_LOGS_REQUEST_FAILED';

export const DBA_PUBLISH_LOGS_CURRENT_ACTION = 'DBA_PUBLISH_LOGS_CURRENT_ACTION';
export const DBA_PUBLISH_LOGS_RESET_ACTION = 'DBA_PUBLISH_LOGS_RESET_ACTION';